import { Component, OnInit, EventEmitter, ViewChild, Output, HostListener } from '@angular/core';
import { Employee } from '../employee.model';
import { EmployeesRest } from '../employee.rest';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from "../../../core/services/permissions/permissions.service";
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-employee-modal',
  templateUrl: './employee-modal.component.html',
  styleUrls: ['./employee-modal.component.scss']
})
export class EmployeeModalComponent implements OnInit, HasPermissions {

  permissions: Permissions;

  public employee: Employee;
  private isNew: boolean;
  private enabled: boolean;
  private isSaving = false;
  constructor(
    private rest: EmployeesRest,
    private permissionService: PermissionsService
  ) { }

  @ViewChild(ModalComponent) public modal: ModalComponent;
  @ViewChild('employeeForm') employeeForm: NgForm;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.employeeForm.valid) {
      this.saveEmployee();
      event.preventDefault();
    }
  }

  ngOnInit() {
  }

  setPermissions(claimType: string){
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  public closeModal() {
    this.modal.close();
  }

  public setModel(employee: Employee, isNew: boolean) {
    this.setPermissions("Employee");
    this.isNew = isNew;
    if (isNew) {
      this.modal.title = 'Dodaj pracownika';
      this.enabled = this.permissions.canAdd;
    } else {
      this.modal.title = 'Edytuj pracownika';
      this.enabled = this.permissions.canEdit;
    }
    this.employee = Object.assign({}, employee);

    if (isNew) {
      this.employee.isActive = true;
    }

    this.modal.openWithCustomSize({ maxwidth: '35vw' });
  }

  private saveEmployee() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    const action = this.rest.saveEmployee;
    action.call(this.rest, this.employee, this.isNew).subscribe((employee: Employee) => {
      const emmitData = { isSuccess: true, isNew: this.isNew, employee: employee };
      this.isSaving = false;
      this.modal.close();
      this.onSuccess.emit(emmitData);
    });
  }
}
